import { render, staticRenderFns } from "./CardEconomic.vue?vue&type=template&id=57b46638&scoped=true&"
import script from "./CardEconomic.vue?vue&type=script&lang=js&"
export * from "./CardEconomic.vue?vue&type=script&lang=js&"
import style0 from "./CardEconomic.vue?vue&type=style&index=0&id=57b46638&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b46638",
  null
  
)

export default component.exports